module.exports = __webpack_public_path__ + "img/teacher1-3.fbb70210.png";